import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { decodeRef, getAccountTransactions, getTransactions, makeJournalEntry } from "./accounts_halper";
import { Box, Button, LinearProgress, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import HtmlTooltip from "../frames/html_tooltip";
import { useNavigate, useParams } from "react-router-dom";

function TransactionList() {
    const [transactions, setTransactions] = useState(null);
    const [allTransactions, setAllTransactions] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadMore, setLoadMore] = useState(true);
    const [accInfo, setAccInfo] = useState({});
    const [page, setPage] = useState(0);
    const param = useParams();
    const account = parseInt(param.account ?? "0");
    const navigator = useNavigate();

    const initData = async (auth) => {
        if (!auth) return;
        if (account === 0) {
            const trans = await getTransactions();
            trans.forEach(itm => {
                itm.balance = 0;
            });
            setTransactions(trans);
            setAllTransactions(trans);
        } else {
            const response = await getAccountTransactions(account, page);
            const trans = response.transaction;
            setAccInfo({
                ac_id: response.ac_id, ac_type: response.ac_type, balance: response.balance,
                created_on: response.created_on, name: response.name,
                opening_balance: response.opening_balance, opening_date: response.opening_date,
                scheme: response.scheme
            });
            const jr = makeJournalEntry(trans, response.opening_balance, response.opening_date, account, false);
            setAllTransactions(jr);
            setTransactions(jr);
        }
        setIsLoading(false);
    }

    const loadMoreData = async (e) => {
        setIsLoading(true);
        const response = await getAccountTransactions(account, page + 1);
        if (response.transaction.length === 0) {
            setLoadMore(false);
        } else {
            const jr = makeJournalEntry(response.transaction, allTransactions[allTransactions.length - 1].balance, response.opening_date, account, true);
            setTransactions([...allTransactions, ...jr]);
            setAllTransactions([...allTransactions, ...jr]);
        }
        setIsLoading(false);
        setPage(page + 1);
    }

    const handleSearch = (event) => {
        if (allTransactions === null) return;
        const newList = allTransactions.filter((itm) =>
            itm.description.toLowerCase().startsWith(event.target.value.toLowerCase())
        );
        if (newList.length === 0) setTransactions(allTransactions)
        else setTransactions(newList);
    }

    return (
        <MenuFrame permission="ACCOUNTS" onInit={initData} screen="TRANSACTION" onSearch={handleSearch}>
            {isLoading ? <LinearProgress color="primary" /> : ""}
            <Box sx={{ mt: 1 }}>
                <Typography variant="subtitle2" color="info">
                    <HtmlTooltip title={<Typography variant="caption" color="primary">
                        Created: {accInfo.created_on}<br />
                        Opening Date: {accInfo.opening_date}<br />
                        Opening Balance: {accInfo.opening_balance}
                    </Typography>}>
                        {accInfo.name} ({accInfo.ac_type})
                    </HtmlTooltip>
                </Typography>
                {account === 0 ?
                    <Typography variant="subtitle2" color="secondary">General Ledger</Typography>
                    :
                    <Typography variant="subtitle2" color="secondary">Balance: ₹ {accInfo.balance?.toFixed(2) ?? "0.00"}</Typography>
                }
                {
                    transactions === null || (transactions[0]?.balance.toFixed(2) ?? "0.00") === (accInfo?.balance?.toFixed(2) ?? "0.00")
                        ? "" : <Typography variant="subtitle2" color="error">❌ Critical Audit Error</Typography>
                }

                <Button variant="contained" className="print-btn" style={{ textTransform: "unset" }} onClick={() => { navigator("/accounts/print-transaction/" + account); }}>
                    &emsp; Print Priview &emsp;
                </Button>
            </Box>
            <Box>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="Transaction List" className="nowrap">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                <TableCell>Date</TableCell>
                                <TableCell>Vch #</TableCell>
                                {/* <TableCell>Debit</TableCell>
                                <TableCell>Credit</TableCell> */}
                                <TableCell>Description</TableCell>
                                <TableCell>Ref</TableCell>
                                {account ?
                                    <>
                                        <TableCell align="right">Debit (Out)</TableCell>
                                        <TableCell align="right">Credit (In)</TableCell>
                                        <TableCell align="right">Balance</TableCell>
                                    </> :
                                    <TableCell align="right">Amount</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactions === null || transactions.length === 0 ? <TableRow><TableCell colSpan={6}><Typography textAlign={"center"} color="textDisabled" variant="caption">No Transaction ...</Typography></TableCell></TableRow> :
                                transactions.map((row, idx) =>
                                    <TableRow key={idx}>
                                        <TableCell>
                                            <Typography variant="body2">{row.vhr_date}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <HtmlTooltip title={row.serial_ref === null ? "" : <Typography variant="caption" color="primary">{decodeRef(row.ref)} Serial: {row.serial_ref ?? ""}</Typography>}>
                                                <Typography variant="body2">{row.vch_num}</Typography>
                                            </HtmlTooltip>
                                        </TableCell>
                                        {/* <TableCell>
                                            <Typography variant="body2">{row.debit_name}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{row.credit_name}</Typography>
                                        </TableCell> */}
                                        <TableCell>
                                            {
                                                row.description === "Opening balance" ?
                                                    <Typography variant="body2" color="textSecondary">FY {row.description}</Typography> :
                                                    <Typography variant="body2">
                                                        <HtmlTooltip title={<Typography variant="caption" color="primary">
                                                            <dl>
                                                                <dt>{row.debit_name} A/c (Dr) to</dt>
                                                                <dd>{row.credit_name} A/c (Cr)</dd>
                                                            </dl>
                                                            ({row.description})</Typography>}>
                                                            {row.description}
                                                        </HtmlTooltip>
                                                    </Typography>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <HtmlTooltip title={<Typography variant="caption" color="primary">Type: {row.vhr_type}<br />Refrence: {decodeRef(row.ref)}</Typography>}>
                                                <Typography variant="body2">{row.ref}</Typography>
                                            </HtmlTooltip>
                                        </TableCell>
                                        {account ?
                                            <>
                                                <TableCell align="right">
                                                    <Typography variant="body2">{row.debit_amt?.toFixed(2)}</Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="body2">{row.credit_amt?.toFixed(2)}</Typography>
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Typography variant="body2">{row.balance?.toFixed(2)}</Typography>
                                                </TableCell>
                                            </> :
                                            <TableCell align="right">
                                                <Typography variant="body2">{row.amount?.toFixed(2)}</Typography>
                                            </TableCell>}
                                    </TableRow>
                                )
                            }
                            {
                                page === 0 || !accInfo.hasOwnProperty("opening_date") ? "" :
                                    <>
                                        <TableRow>
                                            <TableCell>
                                                <Typography variant="body2"></Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2"></Typography>
                                            </TableCell>

                                            <TableCell colSpan={4}>
                                                <Typography variant="body2" fontWeight={"bold"}>Balance CF</Typography>
                                            </TableCell>

                                            <TableCell align="right">
                                                <Typography variant="body2">{page === 0 ? accInfo.opening_balance : (transactions[transactions.length - 1].balance - transactions[transactions.length - 1].credit_amt + transactions[transactions.length - 1].debit_amt)?.toFixed(2)}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </>
                            }
                        </TableBody>
                    </Table>
                    {loadMore ?
                        <Button variant="text" fullWidth textAlign={"center"} className="print-btn" style={{ textTransform: "unset" }} onClick={loadMoreData}>
                            <Typography variant="caption">Load more ...</Typography>
                        </Button>
                        : ""
                    }
                </TableContainer>
            </Box>
            <Link href={"\\files\\20250405-210013.pdf"} style={{ textDecoration: "unset" }} variant="subtitle2">FY24 Account Opening Document</Link>
        </MenuFrame>
    );
}

export default TransactionList;
